export const colors = {
  // PRIMARY BRAND COLORS (Accent 1)
  primaryLightBlue: '#CDE5FF',
  primaryMediumBlue: '#7EB6FF',
  primaryBrightBlue: '#339AF0',
  primaryDeepBlue: '#005EB8',
  primaryDarkBlue: '#003F74',

  // SECONDARY COLORS (Accent 2)
  secondaryPaleBlue: '#C2DBFF',
  secondaryMidBlue: '#78A9FF',
  secondaryRoyalBlue: '#325CAD',
  secondaryNavyBlue: '#002F6C',

  // SEMANTIC COLORS
  errorRed: '#d73527',
  errorRedDark: '#a82319',
  errorRedHover: '#c42e1a',
  errorRedLight: '#ff6b6b',
  successGreen: '#00a854',

  // YELLOWS (Accent 3)
  yellowLight: '#FFF5CC',
  yellowMedium: '#FFE680',
  yellowBright: '#FFD300',
  yellowMustard: '#A68E00',

  // Blue-Grays
  blueGrayLight: '#B3C9D6',
  blueGrayMid: '#7E9DB1',
  blueGrayDark: '#45627D',

  // Neutral Grays
  grayLight: '#F2F2F2',
  grayMid: '#BBBBBB',
  grayMediumDark: '#7D7D7D',
  grayDark: '#4C4C4C',

  // Cool Grays
  coolGrayLight: '#E0E0E0',
  coolGrayMid: '#A8A8A8',
  coolGrayDark: '#707070',
  grayCharcoal: '#3C3C3C',

  // Background Colors
  bgLight: '#FFFFFF',
  bgOffWhite: '#F5F5F5',
  bgLightGray: '#EAEAEA',

  // Dark Theme Colors
  bgDark: '#000000',
  bgDeepGray: '#1A1A1A',
  bgDarkerGray: '#2E2E2E',
};
